import styled from 'styled-components';

const Container = styled.div`
  textarea {
    resize: none;
    border-radius: 3px;
    height: 120px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      height: 14vh;
    }
  }

  select {
    border-radius: 2px;
  }

  a {
    text-decoration: none;
    color: white;
  }

  .ant-space {
    width: 100%;
  }

  .shareContainer {
  }

  .input-email {
    margin-bottom: 10px;
  }

  .form-item-grid {
    display: grid;
    gap: 20px;
    grid-template-columns: 1fr 1fr;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
    }
  }

  .scrollableDivEmails {
    max-height: 175px;
    overflow: auto;
    margin-top: 5px;
  }

  .shareLabel,
  .ant-form-item .ant-form-item-label > label {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    color: ${(props) => props.theme.colors.dark};
    text-transform: uppercase;
  }

  .footer-modal {
    display: flex;
    gap: 16px;
    justify-content: end;
  }

  .ant-select-dropdown .ant-select-item-option-content {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    color: ${(props) => props.theme.colors.dark};
  }

  .ant-select .ant-select-arrow {
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .shareLabel {
    margin-bottom: 15px;
  }

  .shareIconsContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  .shareIconContainer {
    width: 35px;
    height: 35px;
    background-color: #adb5bd;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 50%;
    :hover {
      cursor: pointer;
    }
  }

  .emails {
    margin-bottom: 10px;
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .share-modal-button-submit {
    font-family: ${(props) => props.theme.fonts.oswald};
    background-color: ${(props) => props.theme.colors['terra-cotta']};

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: 100%;
      margin-top: 5px;
    }

    :hover {
      background-color: ${(props) => props.theme.colors['terra-cotta']};
    }
  }

  button.ant-btn.ant-btn-default.ant-btn-lg.share-modal-button-cancel {
    font-family: ${(props) => props.theme.fonts.oswald};
    color: ${(props) => props.theme.colors.dark};

    :hover {
      border: 1px solid ${(props) => props.theme.colors.dark};
    }
  }
`;

export default Container;
